export default __webpack_public_path__ + "b6def0959e44711b95e6e095f8d79d77.png";